// Platform helpers for Web Push. On iOS, Apple only allows notifications
// when the site has been installed to the Home Screen (iOS 16.4+).

export const isIOS = () => {
  const ua = navigator.userAgent || '';
  const iOSDevice = /iPad|iPhone|iPod/.test(ua);
  // iPadOS 13+ reports as Macintosh but has touch points.
  const iPadDesktopUA = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  return iOSDevice || iPadDesktopUA;
};

export const iosVersion = () => {
  const m = (navigator.userAgent || '').match(/OS (\d+)[._](\d+)/);
  if (!m) return null;
  return { major: Number(m[1]), minor: Number(m[2]) };
};

// Web Push on iOS landed in 16.4.
export const iosSupportsPush = () => {
  const v = iosVersion();
  if (!v) return true; // unknown build — assume a recent one
  return v.major > 16 || (v.major === 16 && v.minor >= 4);
};

export const isStandalone = () =>
  window.navigator.standalone === true ||
  window.matchMedia?.('(display-mode: standalone)').matches === true;

/**
 * 'ready'          → push can be requested right now
 * 'ios-install'    → iPhone/iPad in Safari: must Add to Home Screen first
 * 'unsupported'    → browser/OS can't do web push at all
 */
export const pushSupportState = () => {
  const hasApi = 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
  if (isIOS()) {
    if (!iosSupportsPush()) return 'unsupported';
    if (!isStandalone()) return 'ios-install';
    return hasApi ? 'ready' : 'unsupported';
  }
  return hasApi ? 'ready' : 'unsupported';
};
